import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const scheduleRoutes = [
  {
    path: '/schedule',
    name: Routes.Schedule,
    component: () => import('@/pages/contexts/portal/schedule/SchedulePage.vue'),
    meta: {
      pageTitle: 'Schedule',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.FORCE_TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_SCHEDULE,
    },
  },
]
